export enum PublicResultType {
    MailHasBeenSent = 0,
    NewMemberHasBeenRegisted = 1,
    NewMemberHasActivatedAccount = 2,
    DetailsHasBeenSaved = 3,
    EmailChangeConfirmationSent = 4,
    EmailChangeConfirmed = 5
}